import { render } from "./appointments.view.vue?vue&type=template&id=0f2c66a9&scoped=true&ts=true"
import script from "./appointments.view.vue?vue&type=script&lang=ts"
export * from "./appointments.view.vue?vue&type=script&lang=ts"

import "./appointments.view.vue?vue&type=style&index=0&id=0f2c66a9&scoped=true&lang=scss"

import exportComponent from "/agent/_work/1/s/Customer/onlinekiosk_vue_js/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f2c66a9"]])

export default __exports__